import React, { useCallback, useEffect, useState } from "react"
import { toast } from "react-toastify"
import SurveyHeader from "./SurveyHeader"
import SurveyFormSection from "./SurveyFormSection"
import SurveyGlobalSection from "./SurveyGlobalSection"
import { getTenDwcCalculator } from "../../requesters/CalculatorRequester"
import { getCalculatorResult, updateCalculatorResult } from "../../requesters/CalculatorResultsRequester"

function SurveyFormPage({ baseUrl, currentUser }) {
  const [questions, setQuestions] = useState()
  const [form, setForm] = useState([])
  const [currentSection, setCurrentSection] = useState(0)
  const [totalQuestionLength, setTotalQuestionLength] = useState(0)
  const [lastPage, setLastPage] = useState(9)
  const [resultId, setResultId] = useState("")

  useEffect(() => {
    document.title = "Performance Intelligence Academy | 10DWC Survey Questions"
  }, [])

  const fetchQuestionSet = useCallback(() => {
    getTenDwcCalculator(baseUrl, currentUser.active_ten_dwc_id, currentUser).then(res => {
      setQuestions(res.response.json.calc.grouped_questions)
      setTotalQuestionLength(res.response.json.calc.question_length)
      setLastPage(res.response.json.calc.last_page)
    })
  }, [baseUrl, currentUser])

  const fetchCalculatorResult = useCallback(() => {
    getCalculatorResult(baseUrl, currentUser, "10DWC", currentUser.active_ten_dwc_id).then(res => {
      if (res.response.json?.calculator_results?.calc_responses) {
        const retrievedAnswers = res.response.json.calculator_results.calc_responses.map(cr => ({ answer_id: cr.answer_id, number_field: cr.answer_number, sorting_index: cr.question_sorting_index }))
        setResultId(res.response.json?.calculator_results?.id)
        setForm(retrievedAnswers)
        setCurrentSection(retrievedAnswers.length === 110 ? 10 : Math.floor(retrievedAnswers.length / 10))
      }
    })
  }, [baseUrl, currentUser])

  useEffect(() => {
    // Route to linking code page when User not enrolled in a program
    if (!currentUser?.active_ten_dwc_id) {
      window.location.href = "/overview"
    } else {
      fetchQuestionSet()
      fetchCalculatorResult()
    }
  }, [currentUser?.active_ten_dwc_id, fetchQuestionSet, fetchCalculatorResult])

  const onChangeHandler = e => {
    const { name, id } = e.target
    const formCopy = [...form]
    formCopy[name] = { answer_id: id }
    setForm(formCopy)
  }

  const onSlideHandler = e => {
    const { name, id, value } = e.target
    const formCopy = [...form]
    formCopy[name] = { answer_id: id, number_field: value }
    setForm(formCopy)
  }

  const onSubmit = () => {
    const payload = form.filter(e => e)
    updateCalculatorResult(baseUrl, resultId, payload, true, currentUser).then(res => {
      if (res.response?.status === "ok") {
        window.location.href = `/survey/thank-you`
      }
    }).catch(err => {
      toast.error(`Error: ${err.errors[0].detail}`)
    })
  }

  const onSaveHandler = () => {
    const payload = form.filter(e => e)
    updateCalculatorResult(baseUrl, resultId, payload, false, currentUser).then(res => {
      if (res.response?.status === "ok") {
        window.location.href = `/ten-dwc-dashboard`
      }
    }).catch(err => {
      toast.error(`Error: ${err.errors[0].detail}`)
    })
  }

  return (
    <div className="survey-sticky-footer">
      <div className="container survey-sticky-footer__content">
        <SurveyHeader form={form} onSaveHandler={onSaveHandler} />
        {/* Get the first 10 question groups */}
        {!!questions && questions.slice(0, 10).map(question => (
          <SurveyFormSection
            currentSection={currentSection}
            form={form}
            key={question.page_index}
            lastPage={lastPage}
            onChangeHandler={onChangeHandler}
            onSubmit={onSubmit}
            questionSet={question}
            setCurrentSection={setCurrentSection}
            totalQuestionLength={totalQuestionLength} />
      ))}
        {/* The 11th grouped question is global wellbeing */}
        {!!questions && questions[10] && (
        <SurveyGlobalSection
          currentSection={currentSection}
          form={form}
          lastPage={lastPage}
          onChangeHandler={onSlideHandler}
          onSubmit={onSubmit}
          questionSet={questions[10]}
          setCurrentSection={setCurrentSection}
          totalQuestionLength={totalQuestionLength} />
      )}
      </div>
    </div>
  )
}

export default SurveyFormPage
